<template>
  <a-menu
    class="menu"
    :selected-keys="selectedKeys"
    :open-keys.sync="openKeys"
    @openChange="handleOpenChange"
    mode="inline"
    theme="light"
  >
    <template v-for="item in slide">
      <!-- 有子菜单 -->
      <a-sub-menu
      :key="item.key"
        v-if="item.child && item.child.length && $common.AUTH(item.key)"
         :disabled="!item.link">
        <span slot="title">
          <div :class="['havechild',selectedKeys[1] == item.key ? 'have_item' : '']" @click="submenukey(item)">
            <div :class="['icon-card',lightKey == item.key ? 'icon-card-active' : '' ]">
              <a-icon :type="item.icon || 'mail'" />
            </div>
            <span :style="{color: selectedKeys[1] == item.key ? '#0ebff5' : ''}">{{ item.title }}</span>
          </div>
        </span>
        <a-menu-item
          v-for="child in item.child"
          :key="child.key"
          @click="handleChildClick(child, item)"
        >
          {{ child.title }}
        </a-menu-item>
      </a-sub-menu>
      <!-- 无子菜单 -->
      <a-menu-item
        v-else
        :disabled="!item.link"
        :key="item.key"
        @click="handleMenuClick(item)"
      >
        <div class="havechild">
          <div :class="['icon-card',lightKey == item.key ? 'icon-card-active' : '' ]">
            <a-icon :type="item.icon || 'mail'" />
          </div>
          <span>{{ item.title }}</span>
        </div>
      </a-menu-item>
    </template>
  </a-menu>
</template>

<script>
import Slide from "./slide";
import User1 from "./user1";
import store from "../../store/index";

function putSlide(menu, userId) {
  const baseMenu = [
    {
      title: "法院目录",
      link: "directoryManage",
      key: "court:list",
      other: true,
      cur: "3-0",
    },
  ];
  if (userId == 1) {
    menu[8].child = [...baseMenu, ...User1];
    return menu;
  } else {
    menu[8].child = baseMenu;
    return menu;
  }
}

export default {
  data() {
    return {
      slide: putSlide(Slide, this.$store.state.user.id),
      selectedKeys: [],
      openKeys: [],
      lightKey:''
    };
  },
  watch: {
    // 监听路由变化，同步选中状态
    $route() {
      // this.initSelection();
    },
  },
  mounted() {
    this.initSelection();
    // this.setDefaultHomeSelection();
  },
  methods: {
    setDefaultHomeSelection() {
      const isHomeExists = this.checkKeyExists(this.slide, this.homePageKey);
      if (isHomeExists) {
        this.selectedKeys = [this.homePageKey];
        // 检查首页是否为子菜单，是的话保持展开
        this.checkAndOpenParentMenu(this.slide, this.homePageKey);
      } else if (this.slide && this.slide.length > 0) {
        this.lightKey = firstItem.key
        const firstItem = this.slide[0];
        if (firstItem.child && firstItem.child.length > 0) {
          this.selectedKeys = [firstItem.child[0].key];
          this.openKeys = [firstItem.key];
        } else {
          this.selectedKeys = [firstItem.key];
        }
      }
    },
    // 检查并展开子菜单的父级
    checkAndOpenParentMenu(menuItems, targetKey) {
      for (const item of menuItems) {
        if (item.child && item.child.length) {
          const hasTarget = item.child.some((child) => child.key === targetKey);
          this.lightKey = item.key
          if (hasTarget) {
            this.openKeys = [item.key];
            return true;
          }
          if (this.checkAndOpenParentMenu(item.child, targetKey)) {
            return true;
          }
        }
      }
      return false;
    },
    checkKeyExists(menuItems, key) {
      for (const item of menuItems) {
        if (item.key === key) return true;
        if (
          item.child &&
          item.child.length &&
          this.checkKeyExists(item.child, key)
        ) {
          return true;
        }
      }
      return false;
    },
    initSelection() {
      const currentRoute = this.$route.name;
      const findKeyAndParent = (items) => {
        for (const item of items) {
          if (item.link === currentRoute) {
            return { key: item.key, parentKey: null };
          }
          if (item.child && item.child.length) {
            for (const child of item.child) {
              if (child.link === currentRoute) {
                return { key: child.key, parentKey: item.key };
              }
            }
          }
        }
        return null;
      };
      const matched = findKeyAndParent(this.slide);
      if (matched) {
        // 同步选中状态
        this.selectedKeys = [];
        this.selectedKeys = [matched.key];
        this.lightKey = matched.key
        // 同步展开状态（更新 openKeys）
        if (matched.parentKey && matched.key) {
          // 如果是二级菜单，展开其父菜单
          this.openKeys = [matched.parentKey];
          // this.selectedKeys = [matched.key];
           this.selectedKeys.push(matched.parentKey)
        } else {
          // 如果是一级菜单，收起所有展开项
          this.openKeys = [];
        }
      }
    },
    // 处理子菜单展开/收起
    handleOpenChange(keys) {
      // this.openKeys = []
      // const latestOpenKey = keys.find(key => this.openKeys.indexOf(key) === -1);
      // if (this.selectedKeys.indexOf(latestOpenKey) === -1) {

      //   this.openKeys = [keys];
      // } else {
      //   this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      // }
    },
    submenukey(item) {
      
      this.lightKey = item.key
      if (this.openKeys.length > 0) {
        if(this.openKeys == item.key){
          this.openKeys = [item.key];
        }else{
          this.openKeys = [];
        }
      }
    },
    // 处理一级菜单点击
    handleMenuClick(menuItem, isSubMenu = false) { 
      this.lightKey = menuItem.key
      this.selectedKeys = [menuItem.key];
      console.log(menuItem.key);
      
      // 如果是子菜单，打开它
      if (isSubMenu) {
        if (this.openKeys.includes(menuItem.key)) {
          // 当前已展开，点击则收起
          this.openKeys = this.openKeys.filter((key) => key !== menuItem.key);
        } else {
          // 当前未展开，点击则收起其他菜单，只展开当前
          this.openKeys = [menuItem.key];
        }
      } else {
        // 不是子菜单则关闭所有展开项
        this.openKeys = [];
      }
      const user = this.$store.state.user;
      if (menuItem.cur == -1) {
        store.dispatch("updateWatermarks");
        this.linkTo(menuItem);
        return;
      } else if (menuItem.child) {
        // const firstChild = menuItem.child[0];
        // this.selectedKeys = [menuItem.child[0].key];
        // this.handleChildClick(firstChild);
      } else {
        this.linkTo(menuItem);
      }
    },
    // 处理子菜单点击
    handleChildClick(child, parentItem, isSubMenu = false) {
      this.selectedKeys = [child.key,parentItem.key];//选中      
      this.openKeys = [parentItem.key];//打开
      if (!child.link) return;
      if (
        !this.$common.AUTH(child.key) &&
        this.$store.state.user.id != 1 &&
        child.other
      ) {
        this.$message.error("暂无权限");
        return;
      }
      store.dispatch("updateWatermarks");
      this.$router.push({ name: child.link });
    },
    // 跳转路由
    linkTo(j) {
      if (
        !this.$common.AUTH(j.key) &&
        this.$store.state.user.id != 1 &&
        j.other
      ) {
        this.$message.error("暂无权限");
        return false;
      }
      store.dispatch("updateWatermarks");
      if (j.link != this.$route.name) {
        this.$router.push({ name: j.link });
      } else {
        this.$router.go(0);
      }
    },
  },
};
</script>

<style scoped>
/* 自定义选中项背景色和文字颜色 */
.ant-menu-item-selected {
  background-color: #ffffff !important;
  color: #0ebff5 !important;
  border-radius: 15px !important;
  height: 40px !important;
  line-height: 40px !important;
  border-right: none;
}
.ant-menu-item-selected::after {
  border-right: none !important;
}
.havechild {
  display: flex;
  align-items: center;
  gap: 10px;
}
.have_item{
  background: #fff;
  color: #0ebff5 !important;
   width: 180px !important;
    border-radius: 15px !important;
  padding: 0 20px;
  box-sizing: border-box;
  margin-left: -24px;
 
}
/* 鼠标悬停样式 */
.ant-menu-item:hover,
.havechild:hover {
  color: #0ebff5 !important;
  background-color: #fff !important;
  border-radius: 15px !important;
}
.havechild:hover {
  width: 180px !important;
  padding: 0 20px;
  box-sizing: border-box;
  margin-left: -24px;
}
/* 子菜单标题样式 */
.ant-menu-submenu,
.ant-menu-submenu-title:hover {
  color: #fff !important;
  border-radius: 15px !important;
  background: transparent;
}
.ant-menu-item {
  margin-bottom: 15px !important;
  transition: all 0.3s ease !important;
}

/* 子菜单选中样式 */
.ant-menu-submenu-title {
  color: #000 !important;
  background-color: #1bb0f5 !important;
}

.menu {
  max-width: 400px;
  font-size: 18px;
  border: none;
  margin-top: 10px;
  padding: 0 30px;
  box-sizing: border-box;
  background: transparent !important;
  color: #fff;
}

:deep(.ant-menu-sub) {
  background-color: transparent !important; /* 替换为你需要的背景色 */
  color: #fff;
  padding-left: 10px;
}

/* 可选：修改二级菜单项的背景色（hover和选中状态） */
:deep(.ant-menu-sub .ant-menu-item) {
 /* background-color: transparent !important;  */
 /* 子菜单项默认背景透明 */
}

:deep(.ant-menu-sub .ant-menu-item:hover) {
  background-color: #fff !important; /* 子菜单项 hover 背景色 */
}

/* 修复inline模式下的一些样式问题 */
.ant-menu-inline .ant-menu-item,
.ant-menu-inline .ant-menu-submenu-title {
  width: 100% !important;
  /* padding-left: 16px !important; */
}
/* 普通状态下的箭头 */
::v-deep .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
::v-deep .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
  background: #fff !important;
  background-image: none !important;
  color: #fff !important; /* 箭头颜色 */
  font-size: 16px; /* 箭头大小 */
  transition: transform 0.3s ease; /* 过渡动画 */
}

/* 2. 鼠标悬停时的箭头 */
::v-deep .ant-menu-submenu-inline.ant-menu-submenu-active 
> .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
::v-deep .ant-menu-submenu-inline.ant-menu-submenu-active 
> .ant-menu-submenu-title .ant-menu-submenu-arrow::after ,
::v-deep .ant-menu-submenu-inline.ant-menu-submenu-open 
> .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
::v-deep .ant-menu-submenu-inline.ant-menu-submenu-open 
> .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
  background: #1bb0f5 !important;
}

.icon-card{
  background: #fff !important;
  color: #409EFF !important;
  border-radius: 6px !important;
  box-sizing: border-box;
  width: 24px !important;
  height: 24px !important;
  line-height: 24px !important;
  text-align: center !important;
  font-weight: 600;
}
.icon-card:hover{
  background: #409EFF !important;
  color: #fff !important;
}
.icon-card-active{
  background: #409EFF !important;
  color: #fff !important;
  border-radius: 6px !important;
  box-sizing: border-box;
  width: 24px !important;
  height: 24px !important;
  line-height: 24px !important;
  text-align: center !important;
  font-weight: 600;
}
.ant-menu-item .anticon, .ant-menu-submenu-title .anticon {
  margin: auto !important;
  font-size: 12px;
  /* color: #fff; */
}
</style>
